// extracted by mini-css-extract-plugin
export var cardIcon = "_9h-5";
export var cardIconUnframed = "_9h-9";
export var checkboxCard = "_9h-0";
export var checkboxCardSelected = "_9h-4";
export var disabled = "_9h-2";
export var interactive = "_9h-1";
export var outerBorder = "_9h-3";
export var spacerMedium = "_9h-8";
export var spacerSmall = "_9h-7";
export var spacerXsmall = "_9h-6";